module.exports = __webpack_public_path__ + "static/media/filter.0238e49e.svg";